module.exports = __webpack_public_path__ + "static/media/Chingling_gaussian2.12a96ddd.png";